import { Typography, useTheme } from "@mui/material";
import { AmountNotice } from "web_myplann/Goals/Components/AmountSections/AmountNotice";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";
import { formatNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	monthlyRent: number;
	statePension: number;
	privateMonthly: number;
	currencySuffix: string;
};

export const PensionBreakdownRow: React.FC<Props> = ({
	monthlyRent,
	statePension,
	privateMonthly,
	currencySuffix,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<AmountNotice tone="info">
			<LabeledValueRow
				label={
					<Typography variant="caption" color={theme.palette.grey[600]}>
						{t(Resources.Goals.Form.Pension.privateMonthlyLabel)}
					</Typography>
				}
				value={
					<Typography
						variant="bodyStrong"
						color={theme.palette.blue[700]}
						tabular
					>
						{formatNumber(privateMonthly)} {currencySuffix}
					</Typography>
				}
			/>
			<Typography variant="caption" color={theme.palette.grey[500]} tabular>
				{t(Resources.Goals.Form.Pension.privateMonthlyBreakdown, {
					desired: `${formatNumber(monthlyRent)} ${currencySuffix}`,
					state: `${formatNumber(statePension)} ${currencySuffix}`,
				})}
			</Typography>
		</AmountNotice>
	);
};
